/**
 * Check if user prefers reduced motion.
 * Always check this before running animations.
 */
export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Debounce a function call.
 */
export function debounce(fn, wait = 100) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
}

/**
 * Run callback after all deferred vendor scripts (GSAP, Lenis)
 * have loaded. Uses DOMContentLoaded since defer scripts execute first.
 */
export function onReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}
